import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ver-pdf',
  templateUrl: './ver-pdf.component.html',
  styleUrls: ['./ver-pdf.component.css'],
})
export class VerPdfComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<VerPdfComponent>,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient
  ) {}
  carga: any;
  cargaImage: any;
  url: string | any;
  blobData: any;
  messageError: string | null = null;
  loading: boolean = true;

  ngOnInit(): void {
    this.getPdfOS(this.data.num);
  }

  private async getAuthHeaders(): Promise<HttpHeaders> {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      return new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      });
    } catch (error) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
      });
    }
  }

  arrayBufferToBase64(buffer: any) {
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  async getPdfOS(id: string): Promise<void> {
    if (!id) {
      this.messageError = 'ID inválido para generar el PDF.';
      return;
    }

    const url = `${environment.salesApi}/api/v1/getPdfOS/${id}`;

    try {
      const headers = await this.getAuthHeaders();

      this.http.get<any>(url, { headers }).subscribe({
        next: (res: { type: string; data: number[] }) => {
          const byteArray = new Uint8Array(res.data);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);

          this.url = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al obtener el PDF:', error);
          this.messageError = 'Error al obtener el PDF del Orden de Servicio';
          this.loading = false;
        },
      });
    } catch (error) {
      console.error('Error al obtener headers de autenticación:', error);
      this.messageError = 'Error de autenticación';
      this.loading = false;
    }
  }
}
